import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import MainPage from "./scenes/mainpage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
